import { getQueryString } from 'utility/helpers';
import { globalEndpoints } from './global';

export const contentEndpoints = {
  categoryClientContent: '/Content/CategoryClientContent',
  getHomeContent: '/Content/Home',
  getDashboard: (options) => {
    // eslint-disable-next-line no-console
    if (typeof options.sortOrder !== 'undefined') {
      options.sortOrder = options.sortOrder === 'asc' ? 1 : 2;
    }
    if (typeof options.userType !== 'undefined') {
      options.userType = options.userType.id;
    }
    if (typeof options.status !== 'undefined') {
      options.status = options.status.id;
    }
    // eslint-disable-next-line no-console
    return `${globalEndpoints.apiUrl}/Content/Dashboard?${getQueryString(options)}`;
  },
  getContentById: (HomePageContentIdEncrypted: string) => `${globalEndpoints.apiUrl}/Content/${HomePageContentIdEncrypted}/View`,
  addContent: () => {
    return `${globalEndpoints.apiUrl}/Content/New`;
  },
  saveContent: (HomePageContentIdEncrypted: string) => {
    return `${globalEndpoints.apiUrl}/Content/${HomePageContentIdEncrypted}/Save`;
  },
  deleteContent: (HomePageContentIdEncrypted: string) => {
    return `${globalEndpoints.apiUrl}/Content/${HomePageContentIdEncrypted}/Delete`;
  },
  homeContent: () => {
    return `${globalEndpoints.apiUrl}/Content/home`;
  },
  previewContent: (options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Content/preview?${queryString}`;
  }
};
